import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, FormGroup, Well, Panel } from 'react-bootstrap';
import { connect } from 'react-redux';
import $ from 'jquery';
import Button from './Button';
import ConfirmDialog from './ConfirmDialog';
import LoadingProgressBar from './LoadingProgressBar';
import TextInput from './TextInput';
import InvoiceItems from './InvoiceItems';

import {
    userPayPalAccountSetAction, 
    userPayPalDeleteAction
} from '../../actions/userActions';

import { isEmptyObject } from '../../validators/formValidators';
import {
    caseSetServerError,
    casePayPalPayOrderCreateAction,
    casePayPalOrderApproveAction
} from './../../actions/caseActions';
import { getCurrency } from '../../helpers/internationalization';


class PayPalForm extends PureComponent {
    constructor(props) {
        super(props);
        this.onScriptLoaded = this.onScriptLoaded.bind(this);
        this.loadScript = this.loadScript.bind(this);
        this.onError = this.onError.bind(this);
        this.defaultState = {
            scriptLoading: false,
            scriptLoaded: false,
            scriptDidError: false,
            rendered: false
        };
        this.state = this.defaultState;
    }

    componentDidMount() {
        if (this.props.account) {
            this.loadScript();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.account) {
            this.loadScript();
        }
    }

    componentWillUnmount() {
        if (this.loadPromise) {
            this.loadPromise.cancel();
        }
    }

    onScriptLoaded() {
        if (this.state.rendered || typeof window.paypal === 'undefined') {
            return;
        }
        this.setState({rendered: true}, () =>
            window.paypal.Buttons({
                enableStandardCardFields: true,
                createOrder: async(data, actions) => {
                    try {
                        const result = await casePayPalPayOrderCreateAction(this.props.amount, this.props.caseId, this.props.description, this.props.publicHash).promise;
                        return result.data.orderId;
                    } catch (error) {
                        console.error(error);
                        if (this.props.onError) {
                            this.props.onError(error);
                        }
                    }
                    this.props.dispatch(caseSetServerError('Cannot launch PayPal dialog.'));
                },
                onApprove: async(data, actions) => {
                    try {
                        await casePayPalOrderApproveAction(data.orderID, this.props.amount, this.props.description, this.props.caseId, this.props.publicHash).promise;
                        if (this.props.onSuccess) {
                            this.props.onSuccess();
                        }
                        return;
                    } catch (error) {
                        console.error(error);
                        if (this.props.onError) {
                            this.props.onError(error);
                        }
                    }
                    this.props.dispatch(caseSetServerError('Cannot finalize PayPal payment.'));
                }
            }).render('#paypal-button-container'));
    }

    onError(error) {
        if (this.props.onError) {
            this.props.onError(error);
        }
    }

    loadScript() {
        if (this.state.scriptLoaded || this.state.scriptLoading) {
            return;
        }

        if ($('#PayPalScript').length) {
            this.setState({scriptLoaded: true});
            this.setState({scriptLoading: false});
            this.onScriptLoaded();
            return;
        }

        this.setState({scriptLoading: true});
        const script = document.createElement('script');
        if (typeof this.props.onScriptTagCreated === 'function') {
              this.props.onScriptTagCreated(script);
        }

        script.id = 'PayPalScript';
        script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.PAYPAL_CLIENT_ID}&currency=${getCurrency(this.props.country)}&debug=${__DEVELOPMENT__}`;
        script.async = 1;
        this.loadPromise = (() => {
            let canceled = false;
            const promise = new Promise((resolve, reject) => {
                script.onload = () => {
                    this.setState({scriptLoaded: true});
                    this.setState({scriptLoading: false});
                    resolve();
                    this.onScriptLoaded();
                };

                script.onerror = (event) => {
                    this.setState({scriptDidError: true});
                    this.setState({scriptLoading: false});
                    reject(event);
                    this.onError('PayPal service is not responding.');
                };
            });

            const wrappedPromise = new Promise((accept, cancel) => {
                promise.then(() => canceled ? cancel({ isCanceled: true }) : accept()); // eslint-disable-line no-confusing-arrow
                promise.catch(error => canceled ? cancel({ isCanceled: true }) : cancel(error)); // eslint-disable-line no-confusing-arrow
            });

            return {
                promise: wrappedPromise,
                cancel() { canceled = true; }
            };
        })();

        this.loadPromise.promise
          .then(this.onScriptLoaded)
          .catch(this.onError);

        document.body.appendChild(script);
    }

    render() {
        return (
            <React.Fragment>
            <Row>
                <Well>Total Charge: ${this.props.amount / 100.0}</Well>
            </Row>
            <Row>
                <Col>
                {typeof window.paypal === 'undefined' && <LoadingProgressBar loading />}
                </Col>
            </Row>
            <div id="paypal-button-container" />
            </React.Fragment>
        );
    }
}


class PayPal extends PureComponent {
    constructor(props) {
        super(props);
        this.renderSignInButton = this.renderSignInButton.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.signIn = this.signIn.bind(this);
        this.cancel = this.cancel.bind(this);
        this.defaultState = {
            processing: false,
            emailDialogOpen: false,
            email: '',
        };
        this.state = this.defaultState;
    }

    componentDidMount() {
        this.setState({email: this.props.account || ''});
    }

    componentWillReceiveProps(nextProps) {
        this.setState({email: nextProps.account || ''});
    }

    signIn() {
        this.setState({ processing: true });
        this.props.dispatch(userPayPalAccountSetAction(this.state.email))
            .then(() => {
                this.setState({ processing: false, emailDialogOpen: false });
            }).catch((error) => {
                this.props.dispatch(caseSetServerError(error));
                this.setState({ processing: false });
            });
    }
    
    cancel() {
        this.setState({ processing: true });
        this.props.dispatch(userPayPalDeleteAction())
            .then(() => {
                this.setState({ processing: false });

            }).catch((error) => {
                this.props.dispatch(caseSetServerError(error));
                this.setState({ processing: false });
            });
    }

    renderSignInButton() {
        if (this.props.loggedIn && this.props.loggedIn.owner_id !== 0 && isEmptyObject(this.props.account)) {
            return (
                <Row>
                    <Col xs={8} md={9}>
                        <Well><img src="/img/paypal_logo.png" style={{ height: 25, marginRight: 10 }}/> integration missing to activate e-payments.</Well>
                    </Col>
                </Row>
            );
        }

        if (!isEmptyObject(this.props.account)) {
            return (
                <Button label="Disconnect"
                        style={{width: 200}}
                        img="/img/paypal_logo.png"
                        imgStyle={{height: 25}}
                        loading={this.state.processing}
                        onClick={this.cancel}
                        disabled={this.state.processing || this.props.disabled}
                        loadingLabel="Cancelling..."
                        tooltip="Disconnect PayPal account integration."
                />
            );
        }

        let integrateButton = (
            <React.Fragment>
                <Button style={{width: 120}}
                        img="/img/paypal_logo.png"
                        imgStyle={{height: 25}}
                        loading={this.state.processing}
                        onClick={() => this.setState({emailDialogOpen: true})}
                        disabled={this.state.processing || this.props.disabled}
                        tooltip="Integrate payment with your PayPal account"
                />
                <ConfirmDialog title='PayPal Settings'
                               text=''
                               cancel={() => this.setState({emailDialogOpen: false})}
                               confirm={this.signIn}
                               open={this.state.emailDialogOpen}>

                    Set your PayPal email
                    <FormGroup>
                        <TextInput
                            field={{
                                name: 'Email',
                                onChange: evt => this.setState({email: evt.target.value}),
                                value: this.state.email
                            }}
                        />
                    </FormGroup>
                </ConfirmDialog>
            </React.Fragment>
        );

        if (this.props.renderIntegrateButtonOnly) {
            return integrateButton;
        }

        return (
            <Row>
                <Col xs={8} md={9}>
                    {integrateButton}
                </Col>
            </Row>
        );
    }

    renderForm() {
        return (
            <Row style={{ overflow: 'hidden' }}>
            {!isEmptyObject(this.props.invoiceItems) && this.props.invoiceItems.items && this.props.invoiceItems.items.length > 0 && !this.props.showAsDialog && (
                <Col xs={12}>
                <Panel header="Invoice Items">
                    <InvoiceItems invoiceItems={this.props.invoiceItems} />
                </Panel>
                </Col>
            )}
            {this.props.description && !this.props.showAsDialog && (
                <Col xs={12}>
                <Panel header="Description">
                    <Well>{this.props.description.split('\n').map(line => <span>{line}<br /></span>)}</Well>
                </Panel>
                </Col>
            )}
            <Col xs={12}>
            <PayPalForm {...this.props} />
            </Col>
            </Row>
        );
    }

    render() {
        if (!this.props.showAsDialog && (this.props.renderIntegrateButtonOnly || isEmptyObject(this.props.account))) {
            return this.renderSignInButton();
        }

        let result = this.renderForm();
        if (this.props.showAsDialog) {
            result = (
                <ConfirmDialog title="Take Payment Manually"
                               cancel={(evt) => {
                                   $('iframe').remove();
                                   if (this.props.dialogCancel) this.props.dialogCancel(evt);
                               }}
                               open={this.props.dialogOpen}
                               size="large"
                               confirmButton={isEmptyObject(this.props.account) ? this.renderSignInButton() : undefined}
                >
                <Row>
                <Col xs={12}>
                {result}
                </Col>
                </Row>
                </ConfirmDialog>
            );
        }

        return result;
    }
}

PayPal.propTypes = {
    account: PropTypes.string,
    loggedIn: PropTypes.object,
    disabled: PropTypes.bool,
    onError: PropTypes.func.isRequired,
    onSuccess: PropTypes.func,

    // Runs when the script tag is created, but before it is added to the DOM
    onScriptTagCreated: PropTypes.func,
    amount: PropTypes.number,
    caseId: PropTypes.number,
    description: PropTypes.string,
    country: PropTypes.string.isRequired,
    publicHash: PropTypes.string,
    renderIntegrateButtonOnly: PropTypes.bool
};


export default connect()(PayPal);
